export default "__VITE_ASSET__dc7664d8__"